import { TipoServicoEnum } from "@/api/assistencia24h/TipoServicoEnum";
import { QuestionarioBateriaModel } from "@/models/cadastros/assistencia/bateria/QuestionarioBateriaModel";
import { QuestionarioChaveiroModel } from "@/models/cadastros/assistencia/chaveiro/QuestionarioChaveiroModel";
import { FiltroSolicitacaoModel } from "@/models/cadastros/assistencia/FiltroSolicitacaoModel";
import { QuestionarioGuinchoModel } from "@/models/cadastros/assistencia/guincho/QuestionarioGuinchoModel";
import { PrecificacaoModel } from "@/models/cadastros/assistencia/PrecificacaoModel";
import { ResultadoPesquisaSolicitacoesModel } from "@/models/cadastros/assistencia/ResultadoPesquisaSolicitacoesModel";
import { QuestionarioTransporteAssociadoModel } from "@/models/cadastros/assistencia/transporteAssociado/QuestionarioTransporteAssociadoModel";
import { QuestionarioTrocaPneuModel } from "@/models/cadastros/assistencia/troca_pneu/QuestionarioTrocaPneuModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import store from "@/store";
import {
  Action,
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";
import { ConfirmacaoServicoModel } from '@/models/cadastros/assistencia/ConfirmacaoServicoModel';
import { ConfirmacaoSolicitacaoFrotaDTO } from "@/api/assistencia24h/ConfirmacaoSolicitacaoFrotaDTO";

export interface IAssistencia24h extends VuexModule {
  tipoServico: TipoServicoEnum;
  questionarioBateria?: QuestionarioBateriaModel;
  questionarioChaveiro?: QuestionarioChaveiroModel;
  questionarioTrocaPneu?: QuestionarioTrocaPneuModel;
  questionarioGuincho?: QuestionarioGuinchoModel;
  questionarioTransporteAssociado?: QuestionarioTransporteAssociadoModel;
  precificacao?: PrecificacaoModel;
  solicitacoes?: ResultadoPesquisaSolicitacoesModel;
}

const getDefaultState = () => {
  return {
    tipoServico: null,
    questionarioBateria: null,
    questionarioChaveiro: null,
    questionarioTrocaPneu: null,
    questionarioGuincho: null,
    questionarioTransporteAssociado: null,
    currentView: null,
    precificacao: null,
    solicitacoes: null,
  };
};

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "solicitacao-atendimento",
})
class Assistencia24h extends VuexModule {
  tipoServico: TipoServicoEnum | null = null;
  questionarioBateria: QuestionarioBateriaModel | null = null;
  questionarioChaveiro: QuestionarioChaveiroModel | null = null;
  questionarioTrocaPneu: QuestionarioTrocaPneuModel | null = null;
  questionarioGuincho: QuestionarioGuinchoModel | null = null;
  questionarioTransporteAssociado: QuestionarioTransporteAssociadoModel | null = null;
  precificacao: PrecificacaoModel | null = null;
  solicitacoes: ResultadoPesquisaSolicitacoesModel | null = null;

  @Mutation
  RESET() {
    Object.assign(this, getDefaultState());
  }

  @Mutation
  SET_TIPO_SERVICO(payload: TipoServicoEnum) {
    this.tipoServico = payload;
  }

  @Mutation
  SET_QUESTIONARIO_BATERIA(payload: QuestionarioBateriaModel) {
    this.questionarioBateria = payload;
  }

  @Mutation
  SET_QUESTIONARIO_CHAVEIRO(payload: QuestionarioChaveiroModel) {
    this.questionarioChaveiro = payload;
  }

  @Mutation
  SET_QUESTIONARIO_TROCA_PNEU(payload: QuestionarioTrocaPneuModel) {
    this.questionarioTrocaPneu = payload;
  }

  @Mutation
  SET_QUESTIONARIO_GUINCHO(payload: QuestionarioGuinchoModel) {
    this.questionarioGuincho = payload;
  }

  @Mutation
  SET_QUESTIONARIO_TRANSPORTE_ASSOCIADO(
    payload: QuestionarioTransporteAssociadoModel
  ) {
    this.questionarioTransporteAssociado = payload;
  }

  @Mutation
  SET_PRECIFICACAO(payload: PrecificacaoModel) {
    this.precificacao = payload;
  }

  @Mutation
  SET_SOLICITACOES(payload: ResultadoPesquisaSolicitacoesModel) {
    this.solicitacoes = payload;
  }

  @MutationAction({ mutate: ["precificacao"], rawError: true })
  async solicitarPrecificacaoBateria(): Promise<any> {
    const state = this.state as Assistencia24h;
    const questionarioBateria = state.questionarioBateria;
    if (questionarioBateria) {
      if (state.precificacao && state.precificacao.idServico) {
        questionarioBateria.idServico = state.precificacao.idServico;
      }
      const precificacao = await ServicosAssistenciaService.obterPreco(
        questionarioBateria
      );
      return {
        precificacao,
      };
    } else {
      throw Error("Não foi possível obter os dados do questionário");
    }
  }

  @MutationAction({ mutate: ["precificacao"], rawError: true })
  async solicitarPrecificacaoChaveiro() {
    const state = this.state as Assistencia24h;
    const questionarioChaveiro = state.questionarioChaveiro;
    if (questionarioChaveiro) {
      if (state.precificacao && state.precificacao.idServico) {
        questionarioChaveiro.idServico = state.precificacao.idServico;
      }
      const precificacao = await ServicosAssistenciaService.obterPreco(
        questionarioChaveiro
      );
      return {
        precificacao,
      };
    } else {
      throw Error("Não foi possível obter os dados do questionário");
    }
  }

  @MutationAction({ mutate: ["precificacao"], rawError: true })
  async solicitarPrecificacaoTrocaPneu() {
    const state = this.state as Assistencia24h;
    const questionarioTrocaPneu = state.questionarioTrocaPneu;
    if (questionarioTrocaPneu) {
      if (state.precificacao && state.precificacao.idServico) {
        questionarioTrocaPneu.idServico = state.precificacao.idServico;
      }
      const precificacao = await ServicosAssistenciaService.obterPreco(
        questionarioTrocaPneu
      );
      return {
        precificacao,
      };
    } else {
      throw Error("Não foi possível obter os dados do questionário");
    }
  }

  @MutationAction({ mutate: ["precificacao"], rawError: true })
  async solicitarPrecificacaoGuincho() {
    const state = this.state as Assistencia24h;
    const questionarioGuincho = state.questionarioGuincho;
    if (questionarioGuincho) {
      if (state.precificacao && state.precificacao.idServico) {
        questionarioGuincho.idServico = state.precificacao.idServico;
      }
      const precificacao = await ServicosAssistenciaService.obterPreco(
        questionarioGuincho
      );
      return {
        precificacao,
      };
    } else {
      throw Error("Não foi possível obter os dados do questionário");
    }
  }

  @MutationAction({ mutate: ["precificacao"], rawError: true })
  async solicitarPrecificacaoTransporteAssociado() {
    const state = this.state as Assistencia24h;
    const questionarioTransporteAssociado =
      state.questionarioTransporteAssociado;
    if (questionarioTransporteAssociado) {
      if (state.precificacao && state.precificacao.idServico) {
        questionarioTransporteAssociado.idServico =
          state.precificacao.idServico;
      }
      const precificacao = await ServicosAssistenciaService.obterPreco(
        questionarioTransporteAssociado
      );
      return {
        precificacao,
      };
    } else {
      throw Error("Não foi possível obter os dados do questionário");
    }
  }

  @Action({ rawError: true })
  confirmarSolicitacao(confirmacaoServicoModel: ConfirmacaoServicoModel) {
    if (this.precificacao) {
      const idServico = this.precificacao.idServico;
      return ServicosAssistenciaService.confirmarSolicitacao(confirmacaoServicoModel);
    } else {
      throw Error("Não foi possível efetuar a confirmação da solicitação");
    }
  }

  @Action({ rawError: true })
  confirmarSolicitacaoFrota(confirmacaoServicoModel: ConfirmacaoSolicitacaoFrotaDTO) {
    if (this.precificacao) {
      const idServico = this.precificacao.idServico;
      return ServicosAssistenciaService.confirmarSolicitacaoFrota(confirmacaoServicoModel);
    } else {
      throw Error("Não foi possível efetuar a confirmação da solicitação");
    }
  }

  @Action({ rawError: true })
  confirmarSolicitacaoAdm(confirmacaoServicoModel: ConfirmacaoSolicitacaoFrotaDTO) {
    if (this.precificacao) {
      const idServico = this.precificacao.idServico;
      return ServicosAssistenciaService.confirmarSolicitacaoAdm(confirmacaoServicoModel);
    } else {
      throw Error("Não foi possível efetuar a confirmação da solicitação");
    }
  }

  @Action({ rawError: true })
  async recalcularValorServico(confirmacaoServicoModel: ConfirmacaoSolicitacaoFrotaDTO) {
    if (this.precificacao) {
      const idServico = this.precificacao.idServico;
      return ServicosAssistenciaService.recalcularValorServico(confirmacaoServicoModel);
    } else {
      throw Error("Não foi possível efetuar a confirmação da solicitação");
    }
  }
}

export const assistencia24hModule = getModule(Assistencia24h);
